<div class="body">

    <div class="inner">
        <div class="headline">
            Zugang verweigert
        </div>
        <div class="main-content">
            <div class="desc">
                Sie sind nicht dazu berechtigt, diese Komponente zu nutzen. Um diese Komponente nutzen zu können, müssen Ihnen die folgenden Rechte zugewiesen werden:
            </div>
            <ul class="rule-list">
                <li *ngFor="let r of requirements">
                    {{r}}
                </li>
            </ul>
            <div>Fehlercode: (bitte beim Melden des Problems mit angeben)</div>
            <mat-spinner [diameter]="20" *ngIf="logGuid == null; else logGuidAvailable"></mat-spinner>
            <ng-template #logGuidAvailable>
                <div class="log-guid">
                    {{logGuid}}
                </div>
            </ng-template>
        </div>
    </div>
    
</div>